import React from 'react'
import BlogDashboard from './blog/blogDashboard'

function Blog() {
    
    return (
        <>
          <BlogDashboard/>  
        </>
    )
}

export default Blog
